import {ActionIcon, Loader, Tooltip} from '@mantine/core';
import {MdCheckCircle, MdCheckCircleOutline, MdClose} from 'react-icons/md';
import type {ProgressMissionType} from '../../../../../../core/repositories/mypageEntryManagementsRepository';
import {cn} from '../../../../../../lib/classname';

export type MissionsListProps = {
  missions: ProgressMissionType[];
  isLoading?: boolean;
  onClose?: () => void;
};

type MissionItemProps = {
  mission: ProgressMissionType;
  disableTooltip?: boolean;
};

export const MissionItem: React.FC<MissionItemProps> = ({
  mission,
  disableTooltip = false,
}) => {
  const content = (
    <div className="flex gap-4 items-start">
      <div className="flex-shrink-0">
        {mission.completed ? (
          <MdCheckCircle size={16} className="text-success" />
        ) : (
          <MdCheckCircleOutline size={16} className="text-black-2" />
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div
          className={cn('text-sm', {
            'text-black-1': !mission.completed,
            'text-black-2 line-through': mission.completed,
          })}
        >
          {mission.name}
        </div>
      </div>
    </div>
  );

  if (disableTooltip) {
    return content;
  }

  return (
    <Tooltip
      position="top-start"
      width={240}
      multiline
      radius={8}
      withArrow
      label={<div className="text-xs">{mission.description}</div>}
    >
      {content}
    </Tooltip>
  );
};

export const MissionsList: React.FC<MissionsListProps> = ({
  missions,
  isLoading = false,
  onClose,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-8">
        <Loader size="sm" />
      </div>
    );
  }

  const unCompletedMissionsCount = missions.filter(
    (mission) => !mission.completed,
  ).length;

  return (
    <div className="flex flex-col gap-8">
      <div className="w-full flex items-center justify-between text-xs">
        {`残りチュートリアル ${unCompletedMissionsCount} / ${missions.length}`}
        {onClose && (
          <ActionIcon variant="transparent" onClick={onClose}>
            <MdClose size={12} />
          </ActionIcon>
        )}
      </div>
      <div className="flex flex-col gap-4 p-4">
        {missions.map((mission) => (
          <MissionItem key={mission.id} mission={mission} />
        ))}
      </div>
    </div>
  );
};
